import { Button, DatePicker, Row, RowProps, Select, SelectProps } from 'antd'
import styled from 'styled-components'

export const SearchDayWrapper = styled.div<{ margin_bottom?: string; width?: string }>`
  display: flex;
  border: 1px solid;
  border-radius: 5px;
  width: ${({ width }) => (width ? width : 'auto')};
  justify-content: space-between;
  margin-bottom: ${({ margin_bottom }) => (margin_bottom ? `${margin_bottom}px` : '10px')};
`
export const TitleSearch = styled.div<{ width?: string }>`
  min-width: 160px;
  padding: 0 15px;
  font-size: 16px;
  flex-wrap: nowrap;
  display: flex;
  align-items: center;
  border-right: 1px solid;

  @media (max-width: 1670px) {
    width: 160px;
  }
`

export const TableCustom = styled.table`
  border: 1px solid;
  border-top: none;
`
export const HeaderCellWrapper = styled.th`
  border: 1px solid;
  border-top: none;
  min-width: 150px;
  text-align: center;
  background-color: #e2eff9;
  position: sticky;
  top: 0px;
`
export const HeaderCellWrapperCustom = styled.th`
  border-left: 1px solid;
  border-bottom: 1px solid #e2eff9;
  display: block;
  width: max-content;
  padding: 0 10px;
  text-align: center;
  background-color: #e2eff9;
  position: sticky;
  top: 0px;
`

export const HeaderCelDate = styled.th`
  border-top: 1px solid;
  border-top: none;
  text-align: center;
  background-color: #e2eff9;
  position: sticky;
  top: 0px;
`

export const DataCellWrapper = styled.td<{ position?: string; isError?: boolean }>`
  border: 1px solid;
  text-align: ${({ position }) => (position ? position : 'right')};
  padding: 5px;
  background-color: ${({ isError }) => isError && '#f291f1'};
  min-width: 50px;
`
export const DatePickerCustom = styled(DatePicker)`
  @media (min-width: 1670px) {
    width: 120px;
  }

  display: block;
  border: none !important;
`
export const Icon = styled.div`
  font-size: 19px;
  margin: 0 5px;
  display: flex;
  align-items: center;
`
export const RangeDateWrapper = styled.div`
  display: flex;
`

export const SelectWrapper = styled.div`
  width: 280px;

  @media (max-width: 1670px) {
    width: 200px;
  }
`

export const SelectWrapperCustom = styled.div`
  width: 100%;
`

export const CustomSelect = styled(Select)<SelectProps>`
  width: 100%;
  height: 30px;
  opacity: 0.5;
  .ant-select-item-option {
    height: 30px !important;
    line-height: 30px !important;
    padding: 0 8px !important;
  }
`

export const CustomSelectModal = styled(Select)<SelectProps>`
  border: 1px solid black;
  border-radius: 4px;
`

export const ButtonCustom = styled(Button)<{ marginLeft?: string }>`
  width: 100px;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: 15px;

  @media (max-width: 1670px) {
    margin-left: 15px;
  }
`

export const ButtonCustomModal = styled(Button)<{ marginLeft?: string }>`
  width: 100px;
  align-items: center;
  display: flex;
  justify-content: center;
`

export const ButtonWrapper = styled.div`
  display: flex;
`
export const TableWrapper = styled.div`
  width: fit-content;
  text-align: right;
  width: auto;
`
export const EffortWrapper = styled.div`
  font-size: 10px;
  position: sticky;
  top: 10px;
`

export const ContainerTable = styled.div`
  margin-top: 20px;
`

export const WrapperFilter = styled(Row)<RowProps>`
  width: 100%;
  margin: 30px 0;
`
export const CustomHeaderTable = styled.tr`
  position: sticky;
  top: 0px;
`

export const Wrappertable = styled.div`
  border-top: 1px solid;
  height: 600px;
  overflow: auto;
`

export const CustomRowTable = styled.div<{ type?: string }>`
  text-align: ${({ type }) => type};
`
